import { EventActivityEntity } from "@hds-products/event-runtime-entities-common";
import { FrankServiceEntityPersistence } from "@hds/entity-lib";

class EventActivityClientEntity extends EventActivityEntity {
    constructor(ep, seedData = {}, options = {}) {
        super(ep, seedData, options);
    }
    static createInstance(baseUri, seedData, customHeaderFn) {
        const ep = EventActivityClientEntity.createEntityPersistence(baseUri, customHeaderFn);
        return new EventActivityClientEntity(ep, seedData);
    }
    static createEntityPersistence(baseUri, customHeaderFn) {
        const ep = new FrankServiceEntityPersistence(baseUri, EventActivityClientEntity.prototype._meta.entityName, customHeaderFn);
        return ep;
    }
    /*****************************************************/
    // START OVERRIDDEN PROPERTIES
    /*****************************************************/
    set status(newStatus) {
        throw new Error('SET_PROPERTY_NOT_ALLOWED');
    }
    set onBlock(newOnBlock) {
        throw new Error('SET_PROPERTY_NOT_ALLOWED');
    }
    set eventType(newEventType) {
        throw new Error('SET_PROPERTY_NOT_ALLOWED');
    }
    /*****************************************************/
    // END OVERRIDDEN PROPERTIES
    // START OVERRIDDEN METHODS
    /*****************************************************/
    appendEntry() { throw new Error('METHOD_NOT_ALLOWED'); }
    create() { throw new Error('METHOD_NOT_ALLOWED'); }
    upsert() { throw new Error('METHOD_NOT_ALLOWED'); }
    update() { throw new Error('METHOD_NOT_ALLOWED'); }
    patch() { throw new Error('METHOD_NOT_ALLOWED'); }
    replace() { throw new Error('METHOD_NOT_ALLOWED'); }
    delete() { throw new Error('METHOD_NOT_ALLOWED'); }
    /*****************************************************/
    // END OVERRIDDEN METHODS
    /*****************************************************/
}

export { EventActivityClientEntity };
export default EventActivityClientEntity;